export default "__VITE_ASSET__DH9i6nBO__"